
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestridesharelawyers/privacy-policy",
      function () {
        return require("private-next-pages/bestridesharelawyers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestridesharelawyers/privacy-policy"])
      });
    }
  